"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackGoogleTagPageView = exports.TrackGoogleTag = void 0;

var _Console = require("../common/Console");

var TrackGoogleTag = function TrackGoogleTag() {
  if (typeof window === 'undefined') return false;
  if (!gtag) return (0, _Console.warn)('loadGoogleTag must be called first or GoogleTags should be loaded manually');
  return gtag.apply(void 0, arguments);
};

exports.TrackGoogleTag = TrackGoogleTag;

var TrackGoogleTagPageView = function TrackGoogleTagPageView(page) {
  var trackingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (typeof window === 'undefined') return false;
  if (!gtag) return (0, _Console.warn)('loadGoogleTag must be called first or GoogleTags should be loaded manually');
  return gtag('config', trackingId, {
    'page_path': page
  });
};

exports.TrackGoogleTagPageView = TrackGoogleTagPageView;